var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.041 3.905a.9.9 0 0 1-.673-.274.93.93 0 0 1-.271-.679q0-.405.271-.678A.9.9 0 0 1 10.041 2h3.778a.9.9 0 0 1 .673.274.93.93 0 0 1 .271.678q0 .405-.271.679a.9.9 0 0 1-.673.274zM11.93 14.38a.9.9 0 0 0 .673-.274.93.93 0 0 0 .271-.678v-3.81q0-.405-.271-.679a.9.9 0 0 0-.673-.273.9.9 0 0 0-.673.273.93.93 0 0 0-.271.68v3.809q0 .405.271.678a.9.9 0 0 0 .673.274m0 7.619a8.1 8.1 0 0 1-3.294-.679 8.7 8.7 0 0 1-2.703-1.845 8.8 8.8 0 0 1-1.83-2.726 8.3 8.3 0 0 1-.673-3.321q0-1.762.673-3.322a8.8 8.8 0 0 1 1.83-2.726 8.7 8.7 0 0 1 2.703-1.845 8.1 8.1 0 0 1 3.294-.679 8.4 8.4 0 0 1 2.81.476q1.346.477 2.526 1.381l.661-.666a.9.9 0 0 1 .661-.262.89.89 0 0 1 .921.928q0 .405-.26.667l-.66.667a9.3 9.3 0 0 1 1.369 2.547 8.6 8.6 0 0 1 .472 2.834 8.3 8.3 0 0 1-.673 3.321 8.8 8.8 0 0 1-1.83 2.726 8.7 8.7 0 0 1-2.703 1.845A8.1 8.1 0 0 1 11.93 22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerFill);
export default __webpack_public_path__ + "static/media/timer_fill.4a99fdbcad748a81f520ed495781d7f4.svg";
export { ForwardRef as ReactComponent };